import { Injectable } from '@angular/core';

import { JsonService } from '../core/services/json.service';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  key = 'worCache';

  constructor (
    private jsonService: JsonService
  ) {}

  private _getCache () : any {
    return this.jsonService.parse(sessionStorage.getItem(this.key) || '{}');
  }

  private _updateCache ( data : any ) : void {
    sessionStorage.setItem(this.key, JSON.stringify(data));
  }

  get ( name : string ) : any {
    const cache = this._getCache();

    return name in cache
      ? cache[ name ]
      : null;
  }

  put ( name : string, data : any ) : void {
    const cache = this._getCache();

    cache[ name ] = data;

    this._updateCache(cache);
  }

  remove ( name : string ) : void {
    const cache = this._getCache();

    delete cache[ name ];

    this._updateCache(cache);
  }

  removeAll () : void {
    sessionStorage.removeItem(this.key);
  }
}
